import { render, staticRenderFns } from "./PotentialResults.vue?vue&type=template&id=0f431860&scoped=true&"
import script from "./PotentialResults.vue?vue&type=script&lang=js&"
export * from "./PotentialResults.vue?vue&type=script&lang=js&"
import style0 from "./PotentialResults.vue?vue&type=style&index=0&id=0f431860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f431860",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0f431860', component.options)
    } else {
      api.reload('0f431860', component.options)
    }
    module.hot.accept("./PotentialResults.vue?vue&type=template&id=0f431860&scoped=true&", function () {
      api.rerender('0f431860', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/PotentialResults.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/PotentialResults.vue
// module id = 586i
// module chunks = 0